/* eslint-disable max-statements */
import React from 'react';
import { useCheckout } from 'src/Pages/CosmeticDetail/CheckoutProvider';
import { useSellCosmetic } from 'src/Pages/CosmeticDetail/CosmeticSaleProvider';
import Spinner from 'src/Components/Spinner';
import ImageWithPlaceholder from 'src/Components/ImageWithPlaceholder';
import StatsSection from './StatsSection';
import ComingSoonPanel from './StatsSection/ComingSoonPanel';
import icInfoYellow from 'assets/svg/ic_info_yellow.svg';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import icSuccess from 'assets/img/ic_success.png';
import icFailed from 'assets/svg/ic_failed.svg';
import icWarning from 'assets/svg/ic_warning_purple.svg';
import { parseRanking } from 'src/Pages/SpecialEventLeaderBoardPage/LeaderBoardModalProvider/utils';
import styles from './styles.module.scss';
import { CosmeticStatus, CosmeticType, currencyIconMap, RankMedal } from 'src/utils/types';
import CosmeticTypeCard from './CosmeticTypeCard';
import classNames from 'classnames';
import { getButtonGroupStatus, getInventoryButtonStatus, getSaleButtonStatus } from './utils';
import { ButtonGroupStatus, InventoryButtonStatus, SaleButtonStatus } from './types';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { useUserWalletContext } from '@profile/src/Profile_V2/UserWalletProvider';
import CosmeticRarityCard from './CosmeticRarityCard';
import { cosmeticRarityStyleMap } from './config';
import { StatsTab } from './StatsSection/configs';
import BreakpointContent from 'src/Components/BreakpointContent';
import { webImageUri } from 'src/utils/uri';
import { ellipsisMiddle } from 'src/utils/text';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import Button from './Button';
import Button_V2 from 'src/Components/Button_V2';
import { parseCosmeticType } from 'src/Pages/MarketplaceV2/Components/MarketCosmetic/utils';
import SaleHistoryPanel from 'src/Pages/CosmeticDetail/Components/ItemDetailCard/ItemDetail/StatsSection/SaleHistoryPanel';
import { fetchCosmeticSaleHistory } from 'src/redux/actions';
import { updateAvatar } from '@profile/src/redux/remoteActions';
import { ITEMS_PER_PAGE } from 'src/Pages/CosmeticDetail/Components/ItemDetailCard/config';
import BackButton from 'src/Components/BackButton';
import MintButton from 'src/Pages/ItemDetailV2/Components/ItemDetailCard/ItemDetail/MintButton';
import icLocked from 'assets/svg/ic_lock_white_fill.svg';
import { ReactTooltip, TooltipPosition } from 'src/Components/TooltipProviderV2';
import MintContent from 'src/Pages/ItemDetailV2/Components/ItemDetailCard/ItemDetail/ContentTooltips/MintContent';
import { useMintCosmetic } from 'src/Pages/CosmeticDetail/MintCosmeticProvider';
import RankMedalIcon from 'src/Pages/SpecialEventLeaderBoardPage/Components/TableData/Components/RankMedalIcon';
import Alert from 'src/Components/Alert';
import PopupModal from 'src/Components/PopupModal_V2';
import SelectedContent from './ContentTooltips/SelectedContent';

const ItemDetail = ({
  cosmeticDetail,
  className,
  onClickGoBack,
  refreshData
}) => {
  var _cosmeticDetail$saleI;

  const dispatch = useTypedDispatch();
  const [isShowDeco, setShowDeco] = React.useState(true);
  const {
    rarityType: cosmeticRarityClassName,
    deco
  } = cosmeticRarityStyleMap[cosmeticDetail.cosmeticRarity];
  const alertRef = React.useRef(null);
  const [showModal, setShowModal] = React.useState(false);
  const user = useTypedSelector(state => state.userProfile.user);
  const expiredTimeMint = useTypedSelector(state => {
    var _state$ingameBalance$;

    return ((_state$ingameBalance$ = state.ingameBalance.data.userCap) === null || _state$ingameBalance$ === void 0 ? void 0 : _state$ingameBalance$.expiredMintCosmetic) || 0;
  });
  const useRankingLevel = useTypedSelector(state => {
    var _state$userRanking$da;

    return (_state$userRanking$da = state.userRanking.data) === null || _state$userRanking$da === void 0 ? void 0 : _state$userRanking$da.rankingLevel;
  }) || RankMedal.TUTORIAL;
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isBtnLoadingCustom, setIsBtnLoadingCustom] = React.useState(false);
  const {
    checkWalletError
  } = useUserWalletContext();
  const {
    cosmeticConfigs
  } = useTypedSelector(state => state.cosmeticItemsConfigs);
  const {
    data: mintConfig
  } = useTypedSelector(state => state.mintConfig);
  const {
    data,
    totalItems,
    error,
    invalidated,
    loading
  } = useTypedSelector(state => state.cosmeticSaleHistory);
  const selectedCosmetic = useTypedSelector(state => state.selectedCosmetics.data);
  const {
    startCheckout
  } = useCheckout();
  const {
    startSellCosmetic,
    stopSellingCosmetic
  } = useSellCosmetic();
  const {
    mintCosmetic
  } = useMintCosmetic();
  const price = ((_cosmeticDetail$saleI = cosmeticDetail.saleInfo) === null || _cosmeticDetail$saleI === void 0 ? void 0 : _cosmeticDetail$saleI.price) || undefined;
  const groupButtonRef = React.useRef(null);
  const [isShowButtonFixed, setShowButtonFixed] = React.useState(true);
  const isNotMint = cosmeticDetail.cosmeticInfo.status === CosmeticStatus.USER_NOT_MINT;
  const mintBtnDisabled = Date.now() < expiredTimeMint || (mintConfig === null || mintConfig === void 0 ? void 0 : mintConfig.minRankLevel) === undefined || useRankingLevel < mintConfig.minRankLevel;
  const isHiddenMintMsg = (mintConfig === null || mintConfig === void 0 ? void 0 : mintConfig.minRankLevel) === RankMedal.TUTORIAL;
  const {
    loading: loadingMint
  } = useTypedSelector(state => state.mintCosmetic);
  React.useEffect(() => {
    dispatch(fetchCosmeticSaleHistory(cosmeticDetail.id, (currentPage - 1) * ITEMS_PER_PAGE, ITEMS_PER_PAGE));
  }, [currentPage, cosmeticDetail.id, dispatch]);

  const onSaleHistoryPageChange = page => {
    setCurrentPage(page);
  };

  const onClickSelect = async cosmeticDetail => {
    var _alertRef$current2;

    setIsBtnLoadingCustom(true);
    const responseCosmetic = await dispatch(updateAvatar(cosmeticDetail.cosmeticType || CosmeticType.AVATAR, [cosmeticDetail.id]));
    setIsBtnLoadingCustom(false);

    if (!responseCosmetic.error) {
      var _alertRef$current;

      (_alertRef$current = alertRef.current) === null || _alertRef$current === void 0 ? void 0 : _alertRef$current.show({
        icon: icSuccess,
        title: 'Selected'
      });
      return;
    } else (_alertRef$current2 = alertRef.current) === null || _alertRef$current2 === void 0 ? void 0 : _alertRef$current2.show({
      icon: icFailed,
      title: 'Fail to select'
    });
  };

  const handleGroupButton = () => {
    var _groupButtonRef$curre;

    const rect = (_groupButtonRef$curre = groupButtonRef.current) === null || _groupButtonRef$curre === void 0 ? void 0 : _groupButtonRef$curre.getBoundingClientRect();

    if (window.innerHeight >= ((rect === null || rect === void 0 ? void 0 : rect.height) || 0) + ((rect === null || rect === void 0 ? void 0 : rect.top) || 0)) {
      setShowButtonFixed(false);
    } else {
      setShowButtonFixed(true);
    }
  };

  React.useEffect(() => {
    document.addEventListener('scroll', handleGroupButton);
    return () => {
      document.removeEventListener('scroll', handleGroupButton);
    };
  }, []);
  const buttonGroupStatus = getButtonGroupStatus({
    cosmeticDetail,
    currentUser: user
  });
  const isShowWarning = [CosmeticStatus.MINTING, CosmeticStatus.NOT_MINT, CosmeticStatus.FREE, CosmeticStatus.USER_MINTING, CosmeticStatus.PREPARE_SELLING].includes(cosmeticDetail.cosmeticInfo.status);
  const isOwner = (user === null || user === void 0 ? void 0 : user.address.toLocaleLowerCase()) === cosmeticDetail.userAddress.toLocaleLowerCase();
  const inventoryStatus = React.useMemo(() => getInventoryButtonStatus(cosmeticDetail), [cosmeticDetail]);

  const renderStatus = () => {
    if (!isOwner) {
      return null;
    }

    const {
      status
    } = cosmeticDetail.cosmeticInfo;

    switch (status) {
      case CosmeticStatus.USER_NOT_MINT:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.wrapStatus
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.mint
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames(styles.wrapLabel, isHiddenMintMsg && styles.hidenMintMsg)
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.imgLock,
          src: icLocked
        }), /*#__PURE__*/React.createElement("span", {
          className: styles.span
        }, "Not Mint"), /*#__PURE__*/React.createElement(ReactTooltip, {
          className: styles.tooltip,
          position: TooltipPosition.TOP,
          content: /*#__PURE__*/React.createElement(MintContent, null)
        }, /*#__PURE__*/React.createElement("img", {
          className: styles.imgInfo,
          src: icInfo
        }))), !isHiddenMintMsg && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: styles.separation
        }), /*#__PURE__*/React.createElement("div", {
          className: styles.wrapConditional
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.txtBody
        }, "Rank required to mint:"), !!mintConfig && /*#__PURE__*/React.createElement("div", {
          className: styles.wrapValue
        }, /*#__PURE__*/React.createElement(RankMedalIcon, {
          value: mintConfig.minRankLevel,
          className: styles.icRank
        }), /*#__PURE__*/React.createElement("span", {
          className: styles.txtLabel
        }, parseRanking(mintConfig.minRankLevel)))))));

      default:
        return null;
    }
  };

  const renderPopupModal = () => {
    return /*#__PURE__*/React.createElement(PopupModal, {
      onClose: () => setShowModal(false)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.popupContainer
    }, /*#__PURE__*/React.createElement("img", {
      src: icWarning,
      className: styles.iconWarning,
      alt: "warning"
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("span", null, "This item is currently in use. "), /*#__PURE__*/React.createElement("span", null, "Are you sure to sell it?")), /*#__PURE__*/React.createElement("div", {
      className: styles.btnContainer
    }, /*#__PURE__*/React.createElement(Button_V2, {
      type: "secondary",
      title: "cancel",
      className: styles.popupBtn,
      onClick: () => setShowModal(false)
    }), /*#__PURE__*/React.createElement(Button_V2, {
      type: "primary",
      onClick: () => {
        if (checkWalletError()) {
          return;
        }

        startSellCosmetic(cosmeticDetail);
        setShowModal(false);
      },
      title: "sell",
      className: styles.popupBtn
    }))));
  };

  const renderButtonLoading = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.loadingDiv
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: 50,
      secondary: true,
      className: styles.loadingBtn
    }));
  };

  const renderButtonSelect = isSelected => {
    return /*#__PURE__*/React.createElement(Button, {
      disabled: isSelected,
      className: classNames(styles.select, isSelected && styles.disabled),
      onClick: () => {
        if (!cosmeticDetail) return;
        onClickSelect(cosmeticDetail);
      },
      title: isSelected ? 'Selected' : 'Select'
    });
  };

  const renderTooltip = isSelected => {
    return isSelected ? /*#__PURE__*/React.createElement(ReactTooltip, {
      className: styles.tooltipSelected,
      content: /*#__PURE__*/React.createElement(SelectedContent, null),
      position: TooltipPosition.BOTTOM
    }, renderButtonSelect(isSelected)) : renderButtonSelect(isSelected);
  };

  const renderInventoryButton = () => {
    if (!cosmeticDetail.cosmeticInfo) return null;
    const isSelected = (selectedCosmetic === null || selectedCosmetic === void 0 ? void 0 : selectedCosmetic[cosmeticDetail.cosmeticType || CosmeticType.AVATAR].includes(cosmeticDetail.id)) || false;

    switch (inventoryStatus) {
      case InventoryButtonStatus.IS_AVAILABLE:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.btnGroup
        }, cosmeticDetail.cosmeticType === CosmeticType.AVATAR || cosmeticDetail.cosmeticType === CosmeticType.AVATAR_FRAME ? isBtnLoadingCustom ? renderButtonLoading() : renderTooltip(isSelected) : null, /*#__PURE__*/React.createElement(Button, {
          className: classNames(styles.buyNow, styles.sell),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            if (isSelected) setShowModal(true);else startSellCosmetic(cosmeticDetail);
          },
          title: "Sell"
        }), showModal && renderPopupModal(), /*#__PURE__*/React.createElement(Alert, {
          ref: alertRef
        }));

      case InventoryButtonStatus.IS_SELLING:
        return /*#__PURE__*/React.createElement(Button, {
          className: classNames(styles.buyNow, styles.cancel),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            stopSellingCosmetic(cosmeticDetail);
          },
          title: "Stop selling"
        });

      case InventoryButtonStatus.IS_NOT_MINT:
        return /*#__PURE__*/React.createElement(React.Fragment, null, renderStatus(), /*#__PURE__*/React.createElement(MintButton, {
          disabled: mintBtnDisabled,
          loading: loadingMint,
          className: classNames(classNames(styles.buyNow, styles.mintBtn)),
          onClick: () => {
            if (checkWalletError()) {
              return;
            }

            mintCosmetic(cosmeticDetail);
          },
          title: loadingMint ? 'Processing' : 'Mint',
          expiredTime: expiredTimeMint,
          onFinished: refreshData
        }));

      default:
        return null;
    }
  };

  const renderSaleButton = () => {
    if (!cosmeticDetail.cosmeticInfo) return null;
    const saleButtonStatus = getSaleButtonStatus(cosmeticDetail);

    if (saleButtonStatus === SaleButtonStatus.IS_AVAILABLE) {
      return /*#__PURE__*/React.createElement(Button, {
        className: styles.buyNow,
        onClick: () => {
          if (checkWalletError()) {
            return;
          }

          startCheckout(cosmeticDetail);
        },
        title: "Buy"
      });
    }

    return null;
  };

  const renderGuestButton = () => {
    return /*#__PURE__*/React.createElement(Button, {
      className: classNames(styles.buyNow, styles.btnInventory),
      disabled: true,
      title: "Not for sale"
    });
  };

  const renderButton = () => {
    switch (buttonGroupStatus) {
      case ButtonGroupStatus.INVENTORY:
        return renderInventoryButton();

      case ButtonGroupStatus.SALE:
        return renderSaleButton();

      case ButtonGroupStatus.GUEST:
        return renderGuestButton();

      default:
        return null;
    }
  };

  const renderStatusText = () => {
    switch (cosmeticDetail.cosmeticInfo.status) {
      case CosmeticStatus.MINTING:
        return 'Minting your item...';

      case CosmeticStatus.NOT_MINT:
        return "This item is not mint and can't be sold on the marketplace";

      case CosmeticStatus.PREPARE_SELLING:
      case CosmeticStatus.USER_MINTING:
        return 'The blockchain system is processing, please wait...';

      case CosmeticStatus.FREE:
        return "This item is free to use in-game and can't be sold on the marketplace.";

      default:
        return '';
    }
  };

  const renderPrice = () => {
    if (isOwner && isShowWarning) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.warningStatus
      }, /*#__PURE__*/React.createElement("img", {
        src: icInfoYellow,
        className: styles.icon
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.span
      }, renderStatusText()));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.wrapPrice, isNotMint && isOwner && styles.wrapPriceMint)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.priceRow
    }, inventoryStatus === InventoryButtonStatus.IS_SELLING && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapIcon
    }, price && currencyIconMap[price.token] && /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: currencyIconMap[price.token],
      className: styles.icon
    })), /*#__PURE__*/React.createElement("span", {
      className: styles.spanPrice
    }, formatCurrency(price, {
      withCurrency: true,
      trimWholeFraction: true
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapEqual
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.equal
    }, "\u2248")), /*#__PURE__*/React.createElement("span", {
      className: styles.subSpanPrice
    }, formatCurrencyInFiat(price, {
      withCurrency: true,
      trimWholeFraction: true
    })))), renderButton());
  };

  const renderCosmeticInfo = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.wrapInfo, !cosmeticDetail.cosmeticName && styles.emptyName)
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.line, styles[cosmeticRarityClassName])
    }), /*#__PURE__*/React.createElement("span", {
      className: classNames(styles.skinName, styles[cosmeticRarityClassName])
    }, cosmeticDetail.cosmeticName), /*#__PURE__*/React.createElement("span", {
      className: styles.name
    }, parseCosmeticType(cosmeticDetail.cosmeticType))), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapRarity
    }, /*#__PURE__*/React.createElement(CosmeticRarityCard, {
      className: styles.heroRarity,
      value: cosmeticDetail.cosmeticRarity
    }), cosmeticDetail.cosmeticType && /*#__PURE__*/React.createElement(CosmeticTypeCard, {
      itemType: cosmeticDetail.cosmeticType
    })));
  };

  const renderHeroImg = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!cosmeticConfigs && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.ellipse
    }), /*#__PURE__*/React.createElement(ImageWithPlaceholder, {
      className: styles.heroImg,
      src: webImageUri(cosmeticConfigs[cosmeticDetail.cosmeticInfo.typeId].urlImage),
      renderPlaceholder: () => /*#__PURE__*/React.createElement(Spinner, {
        secondary: true,
        className: styles.loading
      })
    })));
  };

  const renderOwner = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapOwner
    }, !!cosmeticDetail.tokenId && /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "ID:"), /*#__PURE__*/React.createElement("span", {
      className: styles.valueID
    }, "#", cosmeticDetail.tokenId)), /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "Owner:"), /*#__PURE__*/React.createElement("span", {
      className: styles.valueOwner
    }, !isOwner ? /*#__PURE__*/React.createElement("span", {
      className: styles.valueOwner
    }, ellipsisMiddle(cosmeticDetail.userAddress.toLocaleLowerCase())) : /*#__PURE__*/React.createElement("span", {
      className: styles.valueOwner
    }, "Owner by me"))));
  };

  const renderedPanel = tab => {
    switch (tab) {
      case StatsTab.Cosmetic:
        {
          return /*#__PURE__*/React.createElement("div", {
            className: styles.container
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.top
          }, /*#__PURE__*/React.createElement("div", {
            className: styles.left
          }, renderHeroImg()), /*#__PURE__*/React.createElement("div", {
            className: styles.right
          }, renderCosmeticInfo(), renderOwner())));
        }

      case StatsTab.Sale:
        {
          return /*#__PURE__*/React.createElement(SaleHistoryPanel, {
            data: data,
            loading: loading,
            error: error,
            invalidate: invalidated,
            totalItems: totalItems,
            currentPage: currentPage,
            onPageChange: onSaleHistoryPageChange
          });
        }

      default:
        {
          return /*#__PURE__*/React.createElement(ComingSoonPanel, null);
        }
    }
  };

  const renderPhonePrice = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.wrapPhonePrice
    }, renderPrice());
  };

  const renderMobileAndTablet = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StatsSection, {
    key: "renderMobileAndTablet",
    tabs: [StatsTab.Cosmetic, StatsTab.Sale],
    className: styles.statsSection,
    renderedPanel: renderedPanel,
    onTabChanged: tab => {
      handleGroupButton();

      if (tab === StatsTab.Cosmetic) {
        setShowDeco(true);
      } else {
        setShowDeco(false);
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: groupButtonRef,
    className: classNames(styles.wrapPhonePrice, styles.nonFixed)
  }, renderPrice()));

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: () => /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }),
    renderPhone: () => isShowDeco ? /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }) : null,
    renderTablet: () => isShowDeco ? /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: deco,
      className: styles.bgHero
    }) : null
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.wrapContainer)
  }, /*#__PURE__*/React.createElement(BackButton, {
    className: styles.backButton,
    label: "Go back",
    onClick: onClickGoBack
  }), /*#__PURE__*/React.createElement(BreakpointContent, {
    renderDesktop: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.top
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.left
    }, renderHeroImg()), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, renderCosmeticInfo(), renderPrice(), renderOwner())), /*#__PURE__*/React.createElement(StatsSection, {
      key: "desktop",
      tabs: [StatsTab.Sale],
      className: styles.statsSection,
      renderedPanel: renderedPanel
    }))),
    renderPhone: renderMobileAndTablet,
    renderTablet: renderMobileAndTablet
  })), isShowButtonFixed && /*#__PURE__*/React.createElement(BreakpointContent, {
    renderPhone: renderPhonePrice,
    renderTablet: renderPhonePrice,
    renderDesktop: () => null
  })));
};

export default ItemDetail;